import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Btn } from "./kit";
import { Modal, Field, TextInput, numOrNull } from "./Form";

export const COMBINE_FIELDS = [
  ["Measurements", [["height_no_shoes_in", "Height, no shoes", "in"], ["height_with_shoes_in", "Height, shoes", "in"], ["weight_lb", "Weight", "lb"], ["wingspan_in", "Wingspan", "in"], ["standing_reach_in", "Standing reach", "in"], ["body_fat_pct", "Body fat", "%"]]],
  ["Athletic testing", [["standing_vert_in", "Standing vert", "in"], ["running_vert_in", "Running vert", "in"], ["bench_reps", "Bench reps", "reps"], ["lane_agility_s", "Lane agility", "sec"], ["three_quarter_sprint_s", "3/4 sprint", "sec"], ["reactive_shuttle_s", "Reactive shuttle", "sec"]]],
];
const KEYS = COMBINE_FIELDS.flatMap(([, f]) => f.map(([k]) => k));
const today = () => new Date().toLocaleDateString("en-CA");
const blank = () => ({ date: today(), ...Object.fromEntries(KEYS.map((k) => [k, ""])) });

export const CombineForm = ({ open, onClose, tid, pid, onSaved }) => {
  const [f, setF] = useState(blank());
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF(blank()); }, [open]);
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const values = Object.fromEntries(KEYS.map((k) => [k, numOrNull(f[k])]));
    if (!f.date) return toast.error("Pick the test date");
    if (Object.values(values).every((v) => v === null)) return toast.error("Enter at least one result");
    if (Object.values(values).some((v) => v !== null && v < 0)) return toast.error("Results can't be negative");
    setBusy(true);
    try {
      await api.post(`/teams/${tid}/players/${pid}/combine`, { player_id: pid, date: f.date, ...values });
      toast.success("Combine session saved — it's in the mobile app too");
      onSaved();
      onClose();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} testid="combine-form-dialog" title="Add combine session" description="Leave anything you didn't test blank.">
      <form onSubmit={submit} className="mt-2 space-y-5">
        <Field label="Test date" className="max-w-[200px]"><TextInput type="date" data-testid="combine-date-input" value={f.date} onChange={set("date")} /></Field>
        {COMBINE_FIELDS.map(([group, fields]) => (
          <fieldset key={group}>
            <legend className="mb-2 font-display text-lg font-bold uppercase text-white">{group}</legend>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {fields.map(([k, label, unit]) => (
                <Field key={k} label={`${label} (${unit})`}>
                  <TextInput type="number" step="0.01" min={0} inputMode="decimal" data-testid={`combine-${k}-input`} value={f[k]} onChange={set(k)} />
                </Field>
              ))}
            </div>
          </fieldset>
        ))}
        <div className="flex justify-end gap-2 pt-2">
          <Btn type="button" variant="ghost" onClick={onClose} data-testid="combine-form-cancel">Cancel</Btn>
          <Btn type="submit" disabled={busy} data-testid="combine-form-save">{busy ? "Saving…" : "Save session"}</Btn>
        </div>
      </form>
    </Modal>
  );
};
